import axios from "@/http"

export function fetchServiceWorkCompanyList(query) {
  return axios({
    url: '/api/v1/service/work/companys',
    method: 'get',
    params: query
  })
}

export function fetchServiceWorkOfferList(query) {
  return axios({
    url: '/api/v1/service/work/offers',
    method: 'get',
    params: query
  })
}
export function deleteServiceWorkOffer(id) {
  return axios({
    url: '/api/v1/service/work/offers/' + id,
    method: 'delete'
  })
}
export function fetchServiceWorkCompany(id) {
  return axios({
    url: '/api/v1/service/work/companys/'+id,
    method: 'get',
    params: { preload: true }
  })
}

export function createServiceWorkCompany(data) {
  return axios({
    url: '/api/v1/service/work/companys',
    method: 'post',
    data
  })
}

export function updateServiceWorkCompany(data) {

  return axios({
    url: '/api/v1/service/work/companys/'+ data.id,
    method: 'put',
    params: data.where?{where: data.where}: undefined,
    data
  })
}
export function EditServiceWorkCompanyProgramme(data) {

  return axios({
    url: '/api/v1/service/work/company/programmes/'+ data.id,
    method: 'put',
    params: data.where?{where: data.where}: undefined,
    data
  })
}
export function AddServiceWorkCompanyProgramme(data){
  return axios({
    url:'/api/v1/service/work/company/programmes',
    method:'POST',
    data
  })
}
export function GetServiceWorkCompanyProgramme(query) {
  return axios({
    url: '/api/v1/service/work/company/programmes',
    method: 'get',
    params: query
  })
}
export function GetServiceWorkOfferDelivererRelations(query){
  // apiv1.GET("/relation/offerdeliverers", v1.GetServiceWorkOfferDelivererRelations)
  return axios({
    url: '/api/v1/service/work/relation/offerdeliverers',
    method: 'get',
    params: query
  })
}
export function createServiceWorkOffer(data) {
  return axios({
    url: '/api/v1/service/work/offers',
    method: 'post',
    data
  })
}
export function updateServiceWorkOffer(data) {

  return axios({
    url: '/api/v1/service/work/offers/'+ data.id,
    method: 'put',
    params: data.where?{where: data.where}: undefined,
    data
  })
}

export function fetchServiceWorkOfferBenefitList(query) {
  return axios({
    url: '/api/v1/service/work/benefits',
    method: 'get',
    params: query
  })
}
export function createServiceWorkOfferBenefit(data) {
  return axios({
    url: '/api/v1/service/work/benefits',
    method: 'post',
    data
  })
}

export function fetchServiceWorkOfferBenefitRelationList(query) {
  return axios({
    url: '/api/v1/service/work/relation/offerbenefits',
    method: 'get',
    params: query
  })
}
export function deleteServiceWorkOfferBenefitRelation(id) {
  return axios({
    url: '/api/v1/service/work/relation/offerbenefits/' + id,
    method: 'delete'
  })
}
export function createServiceWorkOfferBenefitRelation(data) {
  return axios({
    url: '/api/v1/service/work/relation/offerbenefits',
    method: 'post',
    data
  })
}
export function fetchServiceWorkOfferSkillList(query) {
  return axios({
    url: '/api/v1/service/work/skills',
    method: 'get',
    params: query
  })
}
export function createServiceWorkOfferSkill(data) {
  return axios({
    url: '/api/v1/service/work/skills',
    method: 'post',
    data
  })
}
export function createServiceWorkOfferSkillRelation(data) {
  return axios({
    url: '/api/v1/service/work/relation/offerskills',
    method: 'post',
    data
  })
}
export function deleteServiceWorkOfferSkillRelation(id) {
  return axios({
    url: '/api/v1/service/work/relation/offerskills/' + id,
    method: 'delete'
  })
}
export function fetchServiceWorkOfferSkillRelationList(query) {
  return axios({
    url: '/api/v1/service/work/relation/offerskills',
    method: 'get',
    params: query
  })
}

export function GetUserCurriculumVitaes(id){
  return axios({
    url:'/api/v1/user/curriculumvitae?uid='+id+'&preload=true',
    method:'GET',
    data: { preload: true }
    // url: '/api/v1/service/work/companys/'+id,
    // method: 'get',
    // params: { preload: true }
  })
}

export function GetUserCurriculumVitaeBaseinfos(id){
  return axios({
    url:'/api/v1/user/baseinfo/curriculumvitae',
    method:'GET',
    params:{
      where:JSON.stringify({
        user_id:id
      })
    }
  })
}
export function EditServiceWorkOfferDelivererRelation(data){
  return axios({
    url:'/api/v1/service/work/relation/offerdeliverers/'+ data.id,
    method: 'put',
    params: data.where?{where: data.where}: undefined,
    data
  })
}


// WEBPACK FOOTER //
// ./src/api/axj-service/axj-service-work.js